// extracted by mini-css-extract-plugin
export var readonly = "_c7-1";
export var star = "_c7-0";